import { render, staticRenderFns } from "./ColumnLocationDialog.vue?vue&type=template&id=72de9416"
import script from "./ColumnLocationDialog.vue?vue&type=script&lang=js"
export * from "./ColumnLocationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports